(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeePhoneDeleteController',EmployeePhoneDeleteController);

    EmployeePhoneDeleteController.$inject = ['$uibModalInstance', 'entity', 'EmployeePhone'];

    function EmployeePhoneDeleteController($uibModalInstance, entity, EmployeePhone) {
        var vm = this;

        vm.employeePhone = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            EmployeePhone.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
